import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=df61042c&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=df61042c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df61042c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df61042c')) {
      api.createRecord('df61042c', component.options)
    } else {
      api.reload('df61042c', component.options)
    }
    module.hot.accept("./upload-image.vue?vue&type=template&id=df61042c&scoped=true", function () {
      api.rerender('df61042c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/upload-image.vue"
export default component.exports